module.exports = __webpack_public_path__ + "static/plxogimage-dd8469c2ee4eca7069a4990c388d1d9e.jpg";